import { useState } from 'react';

import { useServerClient } from '../useServerClient';
import { useServerParams } from '../useServerParams';

export const regionTypes = {
    country: "country",
    state: "state",
    area: "area"
}

export const targetTypes = {
    state: "state",
    area: "area"
}

export function useRegions({
    regionType: _regionType = '',
    targetType: _targetType = ''
}) {

    const [regionType, setRegionType] = useState(_regionType);
    const [targetType, setTargetType] = useState(_targetType)

    // const [ scopeType, setScopeType ] = useState();

    const { makeCall, getError } = useServerClient();
    const { getListsUrl, _operatorDef: filterOperatorTypes } = useServerParams();

    const [isLoading, setIsLoading] = useState(false)

    const endpoint = "regions";
    const endpoint2 = "region";
    // const endpoint3 = "location/rack";

    const list = async (props) => {

        setIsLoading(true);

        try {

            let { regionType: overrideRegionType } = props

            // if(sType) setScopeType(sType)
            setRegionType(overrideRegionType)

            let endpointUrl = `${endpoint}/${overrideRegionType}`

            // if(scopeType){
            //     endpointUrl += `/${props.id}`
            // }

            // for state option
            if (overrideRegionType === regionTypes.state) {
                endpointUrl += `/${props?.countryId}`
            }

            if (overrideRegionType === regionTypes.area) {
                endpointUrl += `/${props?.stateId}`
            }

            const url = getListsUrl(endpointUrl, props);

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const create = async ({ data }) => {

        setIsLoading(true)

        try {

            const url = endpoint2;

            let postData = {
                scope: {
                    target: targetType,
                    action: "",
                },
                payload: data
            }

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const update = async ({ id, data, targetType: _targetType }) => {

        setIsLoading(true)

        try {

            let url = `${endpoint2}/${id}`

            const postData = {
                scope: {
                    target: targetType,
                    action: "",
                },
                payload: data
            }

            if (_targetType) postData.scope.target = _targetType

            const response = await makeCall({
                url,
                method: "PUT",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const remove = async ({ ids, targetType: overrideTargetType }) => {

        setIsLoading(true);

        // if(ids.length <= 0){
        //     throw getError(false, `Please select at least (1) items`)
        // }

        try {

            const url = `${endpoint}/delete`

            let postData = {
                scope: {
                    target: targetType
                },
                payload: {
                    ids
                }
            }

            if (overrideTargetType) postData.scope.target = overrideTargetType

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const get = async ({ id }) => {

        setIsLoading(true);

        try {

            let url = `${endpoint2}/${regionType}/${id}`

            if (targetType) {
                url = `${endpoint2}/${regionType}/${id}`
            }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    return {
        isLoading,
        filterOperatorTypes,
        regionTypes,
        targetTypes,
        // setTargetType,
        // setScopeType,
        list,
        get,
        create,
        update,
        remove
    }
}